<mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'fund-report-valuation'" [commentSlug]="'fund-cashflows'">
    <mat-card-header class="detail-card-header">
        <mat-card-title data-test="title">Fund Cash Flows</mat-card-title>
    </mat-card-header>
    @if (selectedFundValuationIsInit$ | async; as fundValuationIsInit) {
        <mat-card-content class="detail-card-content">
            @if (fundValuationIsInit) {
                <mat-tab-group [selectedIndex]="0">
                    <mat-tab label="Weighted" data-test="tab-weighted">
                        <ng-template matTabContent>
                            <valumize-fund-cashflow-table
                                [scenarioType]="'WEIGHTED'"
                                [displaySecondaryColumns]="displaySecondaryColumns"
                                [displayPatternColumns]="displayPatternColumns"
                                [displayHurdleColumns]="displayHurdleColumns"
                                [isSensitivityView]="isSensitivityView"
                                [isBottomUpValuation]="isBottomUpValuation()">
                            </valumize-fund-cashflow-table>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Low" data-test="tab-low">
                        <ng-template matTabContent>
                            <valumize-fund-cashflow-table
                                [scenarioType]="'LOW'"
                                [displaySecondaryColumns]="displaySecondaryColumns"
                                [displayPatternColumns]="displayPatternColumns"
                                [displayHurdleColumns]="displayHurdleColumns"
                                [isSensitivityView]="isSensitivityView"
                                [isBottomUpValuation]="isBottomUpValuation()">
                            </valumize-fund-cashflow-table>
                        </ng-template>
                    </mat-tab>

                    <mat-tab label="Base" data-test="tab-base">
                        <ng-template matTabContent>
                            <valumize-fund-cashflow-table
                                [scenarioType]="'BASE'"
                                [displaySecondaryColumns]="displaySecondaryColumns"
                                [displayPatternColumns]="displayPatternColumns"
                                [displayHurdleColumns]="displayHurdleColumns"
                                [isSensitivityView]="isSensitivityView"
                                [isBottomUpValuation]="isBottomUpValuation()">
                            </valumize-fund-cashflow-table>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="High" data-test="tab-high">
                        <ng-template matTabContent>
                            <valumize-fund-cashflow-table
                                [scenarioType]="'HIGH'"
                                [displaySecondaryColumns]="displaySecondaryColumns"
                                [displayPatternColumns]="displayPatternColumns"
                                [displayHurdleColumns]="displayHurdleColumns"
                                [isSensitivityView]="isSensitivityView"
                                [isBottomUpValuation]="isBottomUpValuation()">
                            </valumize-fund-cashflow-table>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            }
        </mat-card-content>
        @if (fundValuationIsInit) {
            <mat-card-actions class="detail-card-actions" style="gap: 1rem;">
                <div>
                    <button [matMenuTriggerFor]="menu" aria-label="More options" mat-icon-button (click)="$event.stopPropagation()">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        @if (!isSensitivityView) {
                            @if (isBottomUpValuation()) {
                                <button mat-menu-item (click)="openNetCurrentAssetDialog()">
                                    <span>Forecast Net Current Assets</span>
                                </button>
                            }
                            <button mat-menu-item (click)="openFundValuationDeferralDialog()" disableRipple>
                                <span>Purchase Price Allocation</span>
                            </button>
                            <button mat-menu-item (click)="openManagementFeeSettingsDialog()" disableRipple>
                                <span>Management Fee Settings</span>
                            </button>
                        }
                        <button mat-menu-item (click)="toggleSecondaryColumns()" disableRipple>
                            <mat-icon>{{ displaySecondaryColumns ? 'visibility' : 'visibility_off' }}</mat-icon>
                            <span>Secondary Cash Flows</span>
                        </button>
                        <button mat-menu-item (click)="toggleHurdleColumns()" disableRipple>
                            <mat-icon>{{ displayHurdleColumns ? 'visibility' : 'visibility_off' }}</mat-icon>
                            <span>Hurdle</span>
                        </button>
                        <button mat-menu-item (click)="togglePatternColumns()" disableRipple>
                            <mat-icon>{{ displayPatternColumns ? 'visibility' : 'visibility_off' }}</mat-icon>
                            <span>Patterns</span>
                        </button>
                    </mat-menu>
                </div>
                <valumize-card-comments-button [commentScope]="'fund-report-valuation'" [commentSlug]="'fund-cashflows'"></valumize-card-comments-button>
            </mat-card-actions>
        }
    } @else {
        <mat-card-content class="detail-card-content" style="color: grey">
            Please select or add a fund valuation to view fund cash flows.
        </mat-card-content>
    }
</mat-card>
